import { jsx as _jsx } from "react/jsx-runtime";
import VibePricingFeature from "../vibe/pricing-feature/index.js";
import { ADDONS } from "constants/addons";
const PricingFeature = ({ addon, selectedUnit })=>{
    if (!addon) {
        return null;
    }
    if (addon === ADDONS.VIBE) {
        return /*#__PURE__*/ _jsx(VibePricingFeature, {
            addon: addon,
            selectedUnit: selectedUnit
        });
    }
    return null;
};
export default PricingFeature;
